var _rect, _rect2, _rect3, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.375,
    y: 2.39453,
    width: 33.25,
    height: 33.2974,
    rx: 6,
    fill: "url(#paint0_radial_3604_12359)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.375,
    y: 2.39453,
    width: 33.25,
    height: 33.2974,
    rx: 6,
    fill: "url(#paint1_radial_3604_12359)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.375,
    y: 2.39453,
    width: 33.25,
    height: 33.2974,
    rx: 6,
    fill: "url(#paint2_radial_3604_12359)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3125 12.5018C27.3125 13.4869 26.515 14.2855 25.5312 14.2855C24.5475 14.2855 23.75 13.4869 23.75 12.5018C23.75 11.5166 24.5475 10.718 25.5312 10.718C26.515 10.718 27.3125 11.5166 27.3125 12.5018Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 24.9883C22.2792 24.9883 24.9375 22.3262 24.9375 19.0423C24.9375 15.7584 22.2792 13.0963 19 13.0963C15.7208 13.0963 13.0625 15.7584 13.0625 19.0423C13.0625 22.3262 15.7208 24.9883 19 24.9883ZM19 22.6099C20.9675 22.6099 22.5625 21.0126 22.5625 19.0423C22.5625 17.072 20.9675 15.4747 19 15.4747C17.0325 15.4747 15.4375 17.072 15.4375 19.0423C15.4375 21.0126 17.0325 22.6099 19 22.6099Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.125 18.5666C7.125 14.5706 7.125 12.5725 7.90158 11.0462C8.58468 9.70368 9.67466 8.61215 11.0153 7.92808C12.5394 7.15039 14.5346 7.15039 18.525 7.15039H19.475C23.4654 7.15039 25.4606 7.15039 26.9847 7.92808C28.3253 8.61215 29.4153 9.70368 30.0984 11.0462C30.875 12.5725 30.875 14.5706 30.875 18.5666L30.875 19.518C30.875 23.514 30.875 25.5121 30.0984 27.0384C29.4153 28.3809 28.3253 29.4725 26.9847 30.1565C25.4606 30.9342 23.4654 30.9342 19.475 30.9342L18.525 30.9342C14.5346 30.9342 12.5394 30.9342 11.0153 30.1565C9.67466 29.4725 8.58468 28.3809 7.90158 27.0384C7.125 25.5121 7.125 23.514 7.125 19.518V18.5666ZM18.525 9.52877H19.475C21.5094 9.52877 22.8923 9.53062 23.9613 9.61808C25.0025 9.70328 25.535 9.8577 25.9065 10.0472C26.8002 10.5033 27.5269 11.231 27.9823 12.126C28.1715 12.498 28.3257 13.0312 28.4108 14.074C28.4982 15.1444 28.5 16.5294 28.5 18.5666L28.5 19.518C28.5 21.5553 28.4982 22.9402 28.4108 24.0107C28.3257 25.0534 28.1715 25.5866 27.9823 25.9586C27.5269 26.8536 26.8002 27.5813 25.9065 28.0374C25.535 28.2269 25.0025 28.3813 23.9613 28.4665C22.8923 28.554 21.5094 28.5558 19.475 28.5558L18.525 28.5558C16.4906 28.5558 15.1077 28.554 14.0387 28.4665C12.9975 28.3813 12.465 28.2269 12.0935 28.0374C11.1998 27.5813 10.4731 26.8536 10.0177 25.9586C9.82846 25.5866 9.67426 25.0534 9.58918 24.0107C9.50185 22.9402 9.5 21.5553 9.5 19.518V18.5666C9.5 16.5294 9.50185 15.1444 9.58918 14.074C9.67426 13.0312 9.82846 12.498 10.0177 12.126C10.4731 11.231 11.1998 10.5033 12.0935 10.0472C12.465 9.8577 12.9975 9.70328 14.0387 9.61808C15.1077 9.53062 16.4906 9.52877 18.525 9.52877Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3604_12359",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.25 27.3675) rotate(-55.414) scale(30.3338 30.3184)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3604_12359",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.0625 36.8811) rotate(-65.1674) scale(26.8621 26.8374)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3604_12359",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.593752 3.58372) rotate(-8.14153) scale(46.1842 9.89183)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.36d360c4f042fca25f92e8d2188e6709.svg";
export { ForwardRef as ReactComponent };